import axios from "@/index";
const shootTJ = {
  state: {
    timeTJList: [],
    areaTJList: [],
    productList: [],
    timeAndAreaTJList: [],
    timeAndProductList: [],
    areaAndProductList: []
  },
  getters: {},
  actions: {
    getTimeTJList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setTimeTJList", (state, { timeTJList: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getAreaTJList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setAreaTJList", (state, { areaTJList: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getProductList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setProductList", (state, { productList: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getTimeAndAreaTJList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setTimeAndAreaTJList",
                (state, { timeAndAreaTJList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getTimeAndProductList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setTimeAndProductList",
                (state, { timeAndProductList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getAreaAndProductList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setAreaAndProductList",
                (state, { areaAndProductList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setTimeTJList(state, action) {
      state.timeTJList = action.timeTJList;
    },
    setAreaTJList(state, action) {
      state.areaTJList = action.areaTJList;
    },
    setProductList(state, action) {
      state.productList = action.productList;
    },
    setTimeAndAreaTJList(state, action) {
      state.timeAndAreaTJList = action.timeAndAreaTJList;
    },
    setTimeAndProductList(state, action) {
      state.timeAndProductList = action.timeAndProductList;
    },
    setAreaAndProductList(state, action) {
      state.areaAndProductList = action.areaAndProductList;
    }
  }
};
export default shootTJ;
